import React, { useState } from "react";
import styled from "@emotion/styled";
import useSWR from "swr";
import RequestCard from "../components/RequestCard";

const STATUSES = [
  { key: "pending", label: "대기중" },
  { key: "processed", label: "처리 완료" },
];

function OutboxPage() {
  const [status, setStatus] = useState("pending");
  const { data, isLoading } = useSWR(
    `/manager/change-request?box=outbox&status=${status}`,
    { refreshInterval: status === "pending" ? 30000 : 0 }
  );
  const items = data?.items || [];

  return (
    <Wrapper>
      <Tabs>
        {STATUSES.map((s) => (
          <Tab
            key={s.key}
            active={s.key === status ? 1 : 0}
            onClick={() => setStatus(s.key)}
          >
            {s.label}
          </Tab>
        ))}
      </Tabs>

      {isLoading && <Loading>불러오는 중...</Loading>}
      {!isLoading && items.length === 0 && (
        <Empty>보낸 요청이 없습니다.</Empty>
      )}
      <List>
        {items.map((item) => (
          <RequestCard key={item.id} item={item} perspective="outbox" />
        ))}
      </List>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const Tabs = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #ffffff;
  border: 1px solid #e6e8eb;
  border-radius: 999px;
  padding: 4px;
  margin-bottom: 4px;
`;
const Tab = styled.button`
  height: 40px;
  border: 0;
  border-radius: 999px;
  background: ${({ active }) => (active ? "#003580" : "transparent")};
  color: ${({ active }) => (active ? "#ffffff" : "#222222")};
  font-size: 14px;
  font-weight: 500;
`;
const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const Empty = styled.div`
  text-align: center;
  color: #888;
  padding: 32px 0;
  font-size: 14px;
`;
const Loading = styled(Empty)``;

export default OutboxPage;
